module.exports = __webpack_public_path__ + "static/media/logo.veva-collect-white.1daff256.png";